const formatDate = {
    methods: {
        formatDate(date){
            return `${date.split(' ')[1].split(':').splice(0, 2).join(':')} - ${date.split(' ')[0].split('-').reverse().join('/')}`
        }
    }
}

export default formatDate;